import { CloudUploadIcon } from "assets";
import { Error } from "components";
import { useEffect, useRef, useState } from "react";
import { FeaturedAdsInput, FeaturedAdsInputError } from '../../state/actionType';

interface FormProps {
  handleImageFileChange?: (file: File) => void;
  formData: FeaturedAdsInput;
  formError: FeaturedAdsInputError;
}

const FeaturedImageForm: React.FC<FormProps> = ({
  handleImageFileChange,
  formData,
  formError
}) => {
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string | "">("");
  useEffect(() => {
    if (formData?.image ) {
      setImagePreviewUrl(formData.image);
    }
  }, [formData?.image]);

  return (
    <div>
     <label
    htmlFor="dropzone-thumbnail"
    onDrop={(e) => {
      e.preventDefault();
      e.stopPropagation();
      const file = e.dataTransfer.files?.[0];
      if (file) {
        setImagePreviewUrl(URL.createObjectURL(file));
        if (handleImageFileChange) handleImageFileChange(file);
      }
    }}
    onDragOver={(e) => e.preventDefault()}
    className="relative flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
  >
    {imagePreviewUrl.length > 0 ? (
      <>
        <img
          src={imagePreviewUrl || ""}
          alt="Group Preview"
          className="absolute inset-0 w-full h-full object-cover rounded-lg opacity-70"
        />
        <div className="z-10 flex flex-col items-center justify-center">
          <CloudUploadIcon />
          <p className="mb-2 text-sm text-white">
            <span className="font-semibold">Click to upload image</span> or drag and drop
          </p>
          <p className="text-xs text-white">JPG, PNG, WebP formats</p>
        </div>
      </>
    ) : (
      <div className="flex flex-col items-center justify-center pt-5 pb-6">
        <CloudUploadIcon />
        <p className="mb-2 text-sm text-gray-500">
          <span className="font-semibold">Click to upload image</span> or drag and drop
        </p>
        <p className="text-xs text-gray-500">JPG, PNG, WebP formats</p>
        {formError.imageFile && <Error>{formError.imageFile}</Error>}
      </div>
    )}
    <input
      id="dropzone-thumbnail"
      type="file"
      accept="image/*"
      className="hidden"
      onChange={(e) => {
        const file = e.target.files?.[0];
        if (file) {
          setImagePreviewUrl(URL.createObjectURL(file));
          if (handleImageFileChange) handleImageFileChange(file);
        }
      }}
    />
  </label>
    </div>
  );
};

export default FeaturedImageForm;
